<template>
	<div class="recharge-page withdraw add-address-page apply clear">
		<top-bar :title="i18n.t('tradeApply.title')" @back="back"></top-bar>


		<div class="form-label">{{i18n.t('tradeApply.label1')}}</div>
		<div class="form-input">
			<input type="text" v-model="form.Email" :placeholder="i18n.t('tradeApply.labelPlaceholder1')">
		</div>

		<div class="form-label">{{i18n.t('tradeApply.label2')}}</div>
		<div class="form-input">
			<input type="text" v-model="form.Telegram" :placeholder="i18n.t('tradeApply.labelPlaceholder2')">
		</div>

		<div class="form-label">{{i18n.t('tradeApply.label3')}}</div>
		<div class="form-input">
			<input type="text" v-model="form.Whatsapp" :placeholder="i18n.t('tradeApply.labelPlaceholder3')">
		</div>

		<div class="form-label">{{i18n.t('tradeApply.label4')}}</div>
		<div class="form-input big">
			<textarea class="textarea" v-model="form.Introduction" :placeholder="i18n.t('tradeApply.labelPlaceholder4')"></textarea>
		</div>

		<div class="form-label">{{i18n.t('tradeApply.label5')}}</div>
		<div class="">
			<CheckboxGroup v-model="form.TradeType" direction="horizontal">
				<Checkbox name="1" shape="square" icon-size="16">{{i18n.t('tradeApply.label6')}}</Checkbox>
				<Checkbox name="2" shape="square" icon-size="16">{{i18n.t('tradeApply.label7')}}</Checkbox>
			</CheckboxGroup>
		</div>

		<div class="bottom-btn apply">
			<Button  class="big" @click="submit">{{i18n.t('tradeApply.btn')}}</Button>
			<Checkbox class="mt-10" v-model="checked" shape="square" icon-size="16">{{i18n.t('tradeApply.role')}}</Checkbox>
		</div>


	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button, CheckboxGroup, Checkbox } from 'vant'
import { traderApply } from '@/api/trade'
export default {
	components: {
    Popup,
    Button,
		topBar,
		CheckboxGroup,
		Checkbox
  },
  data() {
		return {
			form: {
				Email: '',
				Telegram: '',
				Whatsapp: '',
				Introduction: '',
				TradeType: [],
			},
			closeUrl: require('../../assets/imgs/icon-close.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
			showRecharge: false,
      rechargeIndex: 0,
			rechargeInfo: {},
			rechargeInfoBak: {},
			addressData: [],
			checked: false
		}
	},
  mounted() {
		
  },
	methods: {
		back() {
			this.$router.go(-1)
		},
		cancel() {
			this.showRecharge = false
		},
		submit() {
			if (!this.form.Email) {
				this.$toast.fail(this.i18n.t('tradeApply.labelPlaceholder1'))
				return
			}
			if (!this.form.Telegram) {
				this.$toast.fail( this.i18n.t('tradeApply.labelPlaceholder2'))
				return
			}
			if (!this.form.Whatsapp) {
				this.$toast.fail( this.i18n.t('tradeApply.labelPlaceholder3'))
				return
			}
			if (!this.form.Introduction) {
				this.$toast.fail( this.i18n.t('tradeApply.labelPlaceholder4'))
				return
			}
			if (this.form.TradeType.length == 0) {
				this.$toast.fail( this.i18n.t('tradeApply.labelPlaceholder5'))
				return
			}
			if (!this.checked) {
				this.$toast.fail( this.i18n.t('tradeApply.labelPlaceholder6'))
				return
			}

			let form = new FormData()
			form.append('Email', this.form.Email)
			form.append('Telegram', this.form.Telegram)
			form.append('Whatsapp', this.form.Whatsapp)
			form.append('Introduction', this.form.Introduction)
			form.append('TradeType', this.form.TradeType.join())
			traderApply(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('common.success'))
					setTimeout(() => {
						this.back()
					}, 1500);
				} else {
				 this.$toast.fail(res.msg)
				}
			})
		}
	}
}
</script>